import { render, staticRenderFns } from "./p1s1c2c2ConversationsList.vue?vue&type=template&id=2fe36828"
import script from "./p1s1c2c2ConversationsList.vue?vue&type=script&lang=js"
export * from "./p1s1c2c2ConversationsList.vue?vue&type=script&lang=js"
import style0 from "./p1s1c2c2ConversationsList.vue?vue&type=style&index=0&id=2fe36828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports